import { render, staticRenderFns } from "./DrawMenu.vue?vue&type=template&id=55b735d6&scoped=true"
import script from "./DrawMenu.vue?vue&type=script&lang=js"
export * from "./DrawMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawMenu.vue?vue&type=style&index=0&id=55b735d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b735d6",
  null
  
)

export default component.exports